module.exports = __webpack_public_path__ + "static/media/hot_lhlwdg.fabc66f8.png";